import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/summer-vacation-2023-homework/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/summer-vacation-2023-homework',
  name: 'summer_vacation_2023_homework',
  component: Index,
  meta: {
    title: '快乐暑假 开心一夏',
  },
}

export default [indexRoute]
